import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class CategoriaResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }
}

const resource = 'categoria_veiculo';

const moduleHttp = new CategoriaResourceHttp(clientHttp, prefixBase + resource);

export default moduleHttp;
